import { sourceTypes } from "../../constants/cms/sourceType";
import { formActions } from "../../store/actions/cms/form/form.action";
import { pageActions } from "../../store/actions/cms/page/page.action";
import { containerHelper } from "./containerHelper";
import { preConfirmationHelper } from "./preConfirmationHelper";
import { contentHelper } from "./contentHelper";
import { paymentHelper } from "./paymentHelper";
import { elementConstants } from "../../constants/cms/form/element/element.constants";
import { securityHelper } from "../../helpers/securityHelper";
import { content } from "../models/content";

export const cmsHelper = {
    addElementByClick
}


function addElementByClick(enviroment, elements, source, draggableId, dispatch) {
    if (elements === undefined && enviroment === sourceTypes.FORM) {
        return;
    }
    moveElement({
        destination: {
            index: source[getSourceElementPath(enviroment)].length
        },
        draggableId
    },
        source,
        enviroment,
        dispatch,
        elements
    );
}


/* function addElementByDrag(result , sourceObj, elements, dispatch, enviroment ) {
    const { destination, source, draggableId } = result;
    if (!destination) {
        return;
    } else if (elements === undefined) {
        return;
    } else if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
    ) {
        return;
    } else if (
        destination.droppableId === "content" &&
        source.droppableId === "content"
    ) {
        this.sortElements(result);
    } else if (
        destination.droppableId.includes("content") &&
        source.droppableId.includes("sidebar")
    ) {
        this.moveElement(result);
    } else if (
        destination.droppableId.includes("column") &&
        source.droppableId.includes("sidebar")
    ) {
        const newForm = containerHelper.addTo(
            form,
            sourceTypes.FORM,
            elements,
            result
        );
        dispatch(formActions.softUpdate(newForm));
        const containerId = destination.droppableId.slice(
            destination.droppableId.lastIndexOf("-") + 1,
            destination.droppableId.length + 1
        );

        dispatch(cmsActions.containerToUpdate(containerId));
    } else if (
        destination.droppableId.includes("column") &&
        source.droppableId.includes("column") &&
        destination.droppableId === source.droppableId
    ) {
        let newForm = containerHelper.sort(form, result);
        dispatch(formActions.softUpdate(newForm));
    } else if (
        (!source.droppableId.includes("sidebar") &&
            destination.droppableId.includes("content") &&
            source.droppableId.includes("column")) ||
        (destination.droppableId.includes("column") &&
            source.droppableId.includes("content")) ||
        (destination.droppableId.includes("column") &&
            source.droppableId.includes("column"))
    ) {
        let newForm = containerHelper.move(form, sourceTypes.FORM, result);
        dispatch(formActions.softUpdate(newForm));
    }
}
 */

function getElementsFromSource(enviroment, source) {
    switch (enviroment) {
        case sourceTypes.FORM:
            return sortElements(Array.from(source.formElements));
        case sourceTypes.PAGE:
            return sortElements(Array.from(source.pageElements));
        /*   case sourceTypes.TEMPLATE: */

        default:
            return []
    }
}

function sortElements(elements) {
    if (!Array.isArray(elements) || elements.length === 0) return [];
    return elements.sort((a, b) => {
        let x = a.sortOrder;
        let y = b.sortOrder;
        return y < x ? 1 : y > x ? -1 : 0;
    });
}
function findElement(elementInfo, elementList) {
    return elementList.find(el => {
        return (
            el.id === parseInt(elementInfo[1]) &&
            el.type === parseInt(elementInfo[0])
        );
    });
}
function adjustSorting(dropIndex, enviroment, elements, source) {
    return Array.from(elements.map(el => {
        if (
            el.sortOrder >= dropIndex &&
            el.parentId === null
        ) {
            if (enviroment === sourceTypes.FORM && el.page == source.currentPage) {
                el.sortOrder += 1;
            }
            else if (enviroment !== sourceTypes.FORM) {
                el.sortOrder += 1;
            }
        }
        return el;
    }));
}

function moveElement(result, source, enviroment, dispatch, elements = []) {
    const { destination, draggableId } = result;
    /*   const { dispatch, form, elements, event } = this.props; */
    if (elements === undefined) return;
    if (draggableId === undefined) return
    
    const elementInfo = draggableId.split(":");
    const newSource = Object.assign({}, source);
    let newElements = getElementsFromSource(enviroment, newSource);
    const elementList = Array.from(elements);

    let element = findElement(elementInfo, elementList);
    newElements = adjustSorting(destination.index, enviroment, newElements, source)

    const elementsPath = getSourceElementPath(enviroment)

    if (
        element === undefined &&
        parseInt(elementInfo[0]) === elementConstants.CONTAINER
    ) {
        let newContainerElements = containerHelper.create(
            newSource,
            enviroment,
            elementInfo[1],
            destination.index
        );
        newSource[elementsPath] = newElements.concat(newContainerElements);
        /*     newForm.formElements = newFormElements.concat(newContainerElements); */
    } else if (
        element === undefined &&
        parseInt(elementInfo[0]) === elementConstants.PAYMENT_OPTIONS
    ) {
        let newPaymentElement = paymentHelper.create(
            newSource,
            enviroment,
            elementInfo[1],
            destination.index
        );
        /*    newForm.formElements = newFormElements.concat(newPaymentElement); */
        newSource[elementsPath] = newElements.concat(newPaymentElement);
    } else if (
        element === undefined &&
        parseInt(elementInfo[0]) === elementConstants.PRE_CONFIRMATION
    ) {
        let newPreConfiramtionElement = preConfirmationHelper.create(
            newSource,
            enviroment,
            elementInfo[1],
            destination.index
        );

        newElements.push(newPreConfiramtionElement);
        newSource[elementsPath] = newElements
        /*     newForm.formElements = newFormElements; */
    } else if (
        element === undefined &&
        parseInt(elementInfo[0]) === elementConstants.CONTENT
    ) {
        const selectedEl = content.find(el => {
            return el.id === elementInfo[1];
        });

        let contentElement = contentHelper.create(
            newSource,
            enviroment,
            selectedEl,
            destination
        );

        /*     newFormElements.push(contentElement);
            newForm.formElements = newFormElements; */
        newElements.push(contentElement);
        newSource[elementsPath] = newElements

    } else if (element && enviroment === sourceTypes.FORM) {
        element.sortOrder = destination.index;
        element.formId = source.formId;
        element.languageCode = source.languageCode;
        element.contentId = securityHelper.createGuid();
        element.page = source.currentPage;
        element.data =
            typeof element.data === "object"
                ? element.data
                : JSON.parse(element.data);

        /*  newElements.push(element);
         newSource.formElements = newElements; */

        newElements.push(element);
        newSource[elementsPath] = newElements;
    }
    getUpdater(enviroment, newSource, dispatch)
}

function getSourceElementPath(enviroment) {
    switch (enviroment) {
        case sourceTypes.FORM:
            return 'formElements'
        case sourceTypes.PAGE:
            return 'pageElements'
        default:
            break;
    }
}

function getUpdater(enviroment, source, dispatch) {
    switch (enviroment) {
        case sourceTypes.FORM:
            dispatch(formActions.softUpdate(source))
        case sourceTypes.PAGE:
            dispatch(pageActions.softUpdate(source))
        default:
            break;
    }
}